
import { Component, Vue, Watch } from "vue-property-decorator";
import { searchCustomer } from "@/api/customer";
import { getInvoiceList } from "@/api/booking-order";
import Pagination from "@/components/Pagination/index.vue";
import { removeQuotation } from "@/api/inquiry";
import { updatePiRemark } from "@/api/proforma";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import { deepClone } from "@/utils/deepClone";
import { getSettlementInfoStatus,getHeaderInfoTime,getInvoiceSearch,putAllocationRemark,getDetail,getMakeUpInfo,deleteVoucherFile,uploadVoucherFile,putSettlesAmount,putMakeUpInfoReset,putMakeUpInfoUpdate,downloadAllocationPage,getClearingStatus,getCNInfoForIV } from "@/api/invoice"
@Component({
  name: "IvSettleAccount",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private listLoading = true;
  private showDetail = false;
  private showBuCha = false;
  private isShowMore = false;
  private files: File[] = [];
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [
      {
        customerCode: "测试填充",
      },
    ] as any,
  };
  private listParam = {
    customerId: null,
    clearingStatus: null,
    clearAmount: true,
  };
  private infoFields = [
    {
      label: "客人编号",
      prop: "customerCode",
      key: "customerCode",
    },
    {
      label: "客人简称",
      prop: "customerAbbr",
      key: "customerAbbr",
    },
    {
      label: "当前日期",
      prop: "TodayTime",
      key: "TodayTime",
    },
    {
      label: "当前状态",
      prop: "clearingStatus",
      key: "clearingStatus",
    },
    {
      label: "未清账IV金额",
      prop: "unSettlementAmount",
      key: "unSettlementAmount",
    },
    {
      label: "已分配金额",
      prop: "allocatedAmountOfRemittanceAdvice",
      key: "allocatedAmountOfRemittanceAdvice",
    },
    {
      label: "待收款金额",
      prop: "receivableAmount",
      key: "receivableAmount",
    },
    {
      label: "账期时间",
      prop: "ZQTime",
      key: "ZQTime",
    },
    {
      label: "提单时间",
      prop: "TDTime",
      key: "TDTime",
    },
  ] as any;
  private info = { TDTime: "1", ZQTime: "1" } as any;
  private searchForm = [
    {
      label: "清账状态",
      prop: "clearingStatus",
      key: "clearingStatus",
      type: "select",
      value: "",
      options: [],
      placeholder: "请选择",
      resetKey: { label: "desc", value: "name" },
    },
  ];
  private tableCol = [
    {
      label: "IV号码",
      prop: "ivCode",
      key: "ivCode",
      width: "90",
      show: true,
      disabled: false,
    },
    {
      label: "币种",
      prop: "currency",
      key: "currency",
      width: "50",
      show: true,
      disabled: false,
    },
    {
      label: "IV货款金额",
      prop: "ivAmountForGoods",
      key: "ivAmountForGoods",
      show: true,
      disabled: false,
    },
    {
      label: " 报关费用",
      prop: "declarationCharge",
      key: "declarationCharge",
      show: true,
      disabled: false,
    },
    {
      label: "IV其他金额",
      prop: "ivOtherFee",
      key: "ivOtherFee",
      show: true,
      disabled: false,
    },
    {
      label: "IV票面金额",
      prop: "ivTotalAmount",
      key: "ivTotalAmount",
      show: true,
      disabled: false,
    },
    {
      label: "提单日期",
      prop: "dateOfBillOfLoading",
      key: "dateOfBillOfLoading",
      show: true,
      disabled: false,
    },
    {
      label: "CN/DN金额",
      prop: "cnAmount",
      key: "cnAmount",
      show: true,
      disabled: false,
    },
    {
      label: "分配金额",
      prop: "allocatedAmount",
      key: "allocatedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "账期",
      prop: "agreedPaymentTerm",
      key: "agreedPaymentTerm",
      show: true,
      disabled: false,
    },
    {
      label: "清账/逾期天数",
      prop: "overdueNumberOfDays",
      key: "overdueNumberOfDays",
      show: true,
      disabled: false,
    },
    {
      label: "待分配金额",
      prop: "noAllocatedAmount",
      key: "noAllocatedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "补差金额",
      prop: "makeUpTheDifferenceAmount",
      key: "makeUpTheDifferenceAmount",
      show: true,
      disabled: false,
    },
    {
      label: "状态",
      prop: "clearingStatus",
      key: "clearingStatus",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "查看详情",
          code: "",
          click: "handleSeeDetail",
        },
        {
          name: "清账",
          code: "",
          key: "clearingStatus",
          value: "已完成",
          click: "handleToQZ",
        },
        {
          name: "补差",
          code: '',
          click: "handleSeeBuCha",
          key: 'clearingStatus',
          value: '未清账,部分分配'
        },
        {
          name: "重置补差",
          code: '',
          click: "redoDifference",
          key: 'clearingStatus',
          value: '已完成',
          key2: 'makeUpTheDifferenceAmount',
          value2: ''
        },
        {
          name: "绑定CN详情",
          code: "",
          click: "handleCNInfo",
        }
      ],
      show: true,
      disabled: false,
      width: 180,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      type: "remark",
      show: true,
      disabled: false,
    },
  ] as any;

  private DetailTableList = [] as any;

  private DetailTableCol = [
    {
      label: "单据号码",
      prop: "code",
      key: "code",
      show: true,
      disabled: false,
    },
    {
      label: "到账金额",
      prop: "amountReceived",
      key: "amountReceived",
      show: true,
      disabled: false,
    },
    {
      label: "其他费用",
      prop: "handingFee",
      key: "handingFee",
      show: true,
      disabled: false,
    },
    {
      label: "剩余可分配",
      prop: "unAllocatedAmount",
      key: "unAllocatedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "本单分配",
      prop: "allocatedAmountOfThis",
      key: "allocatedAmountOfThis",
      show: true,
      disabled: false,
    },
    {
      label: "收汇单备注",
      prop: "remark",
      key: "remark",
      type: "link",
      show: true,
      disabled: false,
      length: 255,
    },
  ];

  private DetailList = [
    {
      label: "报关合同号",
      prop: "bookingOrderCode",
      key: "bookingOrderCode",
      type: "input",
      placeholder: "请输入报关合同号",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
    {
      label: "IV号码",
      prop: "ivCode",
      key: "ivCode",
      type: "input",
      placeholder: "请输入IV号码",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
    {
      label: "状态",
      prop: "clearStatus",
      key: "clearStatus",
      type: "input",
      placeholder: "请输入状态",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
    {
      label: "结算总金额",
      prop: "settlementAmount",
      key: "settlementAmount",
      type: "input",
      placeholder: "请输入结算总金额",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
    {
      label: "补差金额",
      prop: "makeUpTheDifferenceAmount",
      key: "makeUpTheDifferenceAmount",
      type: "input",
      placeholder: "请输入补差金额",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
    {
      label: "补差备注",
      prop: "makeUpTheDifferenceRemark",
      key: "makeUpTheDifferenceRemark",
      type: "textarea",
      placeholder: "请输入补差备注",
      clearable: true,
      maxlength: 512,
      disabled: true,
    },
    {
      label: "分配金额合计",
      prop: "allocatedAmount",
      key: "allocatedAmount",
      type: "input",
      placeholder: "请输入分配金额合计",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
    {
      label: "未清账金额",
      prop: "noAllocatedAmount",
      key: "noAllocatedAmount",
      type: "input",
      placeholder: "请输入未清账金额",
      clearable: true,
      maxlength: 100,
      disabled: true,
    },
  ];
  private DetailForm = {};

  private BuChaTableCol = [
    {
      label: "文件名",
      prop: "fileName",
      key: "fileName",
      show: true,
      disabled: false,
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      show: true,
      options: [
        {
          name: "删除",
          code: "",
          type: "delete",
          click: "handleBuChaWJDetele",
        },
        {
          name: "下载",
          code: "",
          click: "handleBuChaWJDownload",
        }
      ],
      disabled: false,
    },
    {
      label: "上传时间",
      prop: "uploadTime",
      key: "uploadTime",
      show: true,
      disabled: false,
    },
  ];
  private CNInfoList = [] as any;
  private CNInfoCol = [
    {
      label: "CN号码",
      prop: "creditNoteCode",
      key: "creditNoteCode",
      show: true,
      disabled: false,
    },
    {
      label: "CN金额",
      prop: "creditNoteAmount",
      key: "creditNoteAmount",
      show: true,
      disabled: false,
    },
    {
      label: "分配金额",
      prop: "amount",
      key: "amount",
      show: true,
      disabled: false,
    },
    {
      label: "原因类型",
      prop: "reason",
      key: "reason",
      show: true,
      disabled: false,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
    {
      label: "时间",
      prop: "time",
      key: "time",
      show: true,
      disabled: false,
    }
  ] as any;
  private CNInfoLoading = false;
  private showCNInfo = false;

  private BuChaTableList = [];
  private BuChaList = [
    {
      label: "补差金额",
      prop: "amount",
      key: "amount",
      type: "input",
      placeholder: "请输入补差金额",
      clearable: true,
      disabled: true,
      maxlength: 100,
    },
    {
      label: "补差备注",
      prop: "remark",
      key: "remark",
      type: "textarea",
      placeholder: "请输入补差备注",
      clearable: true,
      maxlength: 512,
    },
  ];
  private BuChaForm = {} as any;
  private customerId: any = "";

  created() {
    this.init();
  }
  activated() {
    this.init();
  }
  private addFile(file: File) {
    // this.files = [file];
    this.files.push(file);
  }
  private init() {
    this.customerId = this.$route.query.customerId?this.$route.query.customerId:''
    this.listParam.customerId = this.$route.query.customerId?this.$route.query.customerId:''
    this.info.customerCode = this.$route.query.customerCode?this.$route.query.customerCode:''
    this.info.customerAbbr = this.$route.query.customerAbbr?this.$route.query.customerAbbr:''
    this.info.clearingStatus = this.$route.query.status?this.$route.query.status:''
    this.info.unSettlementAmount = this.$route.query.unSettlementAmount?this.$route.query.unSettlementAmount:''
    this.info.allocatedAmountOfRemittanceAdvice = this.$route.query.allocatedAmountOfRemittanceAdvice?this.$route.query.allocatedAmountOfRemittanceAdvice:''
    this.info.receivableAmount = this.$route.query.receivableAmount?this.$route.query.receivableAmount:''
    this.getSettlementInfoStatus();
    this.getTodayDate();
    // this.searchCustomer();
    this.getList();
  }
  private async getSettlementInfoStatus() {
    // const res:any = await getSettlementInfoStatus()
    // 说是换接口 IV清账的状态要与IV管理的一致 -- xj
    const res: any = await getClearingStatus();
    this.searchForm[0].options = res
    let newOBJ:any = {desc:'全部',name: 'ALL_STATUS'}
    this.searchForm[0].options.push(newOBJ)
  }
  private async getHeaderInfoTime(id) {
    let params = {
      customerId: id,
    };
    const res: any = await getHeaderInfoTime(params);
    if (res.startDateOfAccountPeriod && res.endDateOfAccountPeriod) {
      this.info.ZQTime =
        res.startDateOfAccountPeriod + "~" + res.endDateOfAccountPeriod;
      console.log("1111111111", this.info);
    }
    if (res.startDateOfBillOfLoading && res.endDateOfBillOfLoading) {
      this.info.TDTime =
        res.startDateOfBillOfLoading + "~" + res.endDateOfBillOfLoading;
      console.log("22222222222", this.info);
    }
  }
  private getTodayDate() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    this.info.TodayTime = year + "-" + month + "-" + day;
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, content }: any = await getInvoiceSearch(params);
    this.table.total = +total;
    this.table.list = content;
    this.getHeaderInfoTime(this.customerId);
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }
  private isExporting = false;

  // 导出
  private handleExport() {
    this.isExporting = true;
    let table = this.tableCol.slice(0, this.tableCol.length - 1);
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `客人IV管理-${new Date()}`
    );
    this.isExporting = false;
  }

  // 跳转IV管理
  private handleToIVM(row) {
    console.log("点击跳转查看详情", row.row);
    this.$router.push(`/customer-iv-managementInfo`);
  }
  // 跳装 收汇单 并且携带客人参数
  private handleToSHD(row) {
    this.$router.push(
      `/collectionManagement?customerID=${row.row.customerID}`
    );
  }

  private async handleCNInfo(row) {
    this.CNInfoLoading = true;
    await getCNInfoForIV(row.row.bookingOrderId).then((res:any) => {
      this.CNInfoList = res;
      this.showCNInfo = true;
      this.CNInfoLoading = false;
    }).catch(err => {
      console.log(err);
      this.CNInfoLoading = false;
    })
  }

  private async handleDelete(scope) {
    await removeQuotation({
      detailId: scope.row.approvalRecordId,
    });
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  // 填写备注
  private async handleRemark(item) {
    try {
      let data = {
        remark: item.remark,
      }
      let params = {
        clearAmountPage: true
      }
      await putAllocationRemark(item.bookingOrderId, data, params);
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    } catch (e) {
      await this.getList();
    }
  }
  private async searchCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.searchForm[0].options = res;
  }

  private redoDifference(row) {
    this.bookingOrderId = row.row.bookingOrderId
    this.$confirm("确定重置吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
    .then(async () => {
      await putMakeUpInfoReset(row.row.bookingOrderId).then(res => {
        this.$notify({
          title: "提示",
          message: "重置成功",
          type: "success",
          duration: 2000
        });
        this.getBuChaList()
        this.getList()
      }).catch(err => {
        console.log(err)
      })
    })
    .catch((err) => {
      console.error(err);
    });
  }

  private querySearch(data) {
    this.listParam = Object.assign(this.listParam, data);
    // const { time, ...rest } = params;
    // if (time && time.length) {
    //   rest.lastUpdateStart = time[0];
    //   rest.lastUpdateEnd = time[1];
    // }
    // this.listParam = rest;
    this.table.pageNumber = 1;
    this.getList();
  }
  private confirmSuccess() {
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private handleCustomer() {
    this.isShowMore = !this.isShowMore;
  }

  private clearingStatus: any = "";

  private async handleSeeBuCha(row) {
    this.bookingOrderId = row.row.bookingOrderId;
    this.clearingStatus = row.row.clearingStatus;
    this.loading = true;
    const res: any = await getMakeUpInfo(row.row.bookingOrderId);
    this.BuChaTableList = res.infos;
    this.BuChaForm = res;
    this.loading = false;
    this.showBuCha = true;
  }

  private bookingOrderId: any = "";

  private async handleSeeDetail(row) {
    this.loading = true;
    const res: any = await getDetail(row.row.bookingOrderId);
    this.DetailForm = res;
    this.DetailTableList = res.infos;
    this.showDetail = true;
    this.loading = false;
  }
  private uploadPZ() {
    this.$refs["upload"]["$refs"]["upload-inner"].handleClick();
  }
  private async handleUpload() {
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    this.uploadJieKou(formData);
  }

  private async uploadJieKou(formData) {
    await uploadVoucherFile(this.bookingOrderId, formData);
    this.$notify({
      title: "成功",
      message: "上传成功",
      type: "success",
      duration: 2000,
    });
    this.getBuChaList();
  }
  private async getBuChaList() {
    this.loading = true;
    const res: any = await getMakeUpInfo(this.bookingOrderId);
    this.BuChaTableList = res.infos;
    this.BuChaForm = res;
    this.loading = false;
  }
  private handleBuChaWJDownload(row) {
    if (row.row.url) {
      window.open(row.row.url);
    } else {
      this.$notify({
        title: "提示",
        message: "暂无下载地址",
        type: "error",
        duration: 2000,
      });
    }
  }
  private async handleBuChaWJDetele(row) {
    let ids = [row.row.id];
    const params = ids.map((id) => `ids=${id}`).join("&");
    await deleteVoucherFile(params);
    this.$notify({
      title: "提示",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getBuChaList();
  }
  private async handleToQZ(row) {
    this.$confirm('确定执行清账吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then( async () => {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      await putSettlesAmount(row.row.bookingOrderId).then(res => {
        this.$notify({
          title: "提示",
          message: "清账成功",
          type: "success",
          duration: 2000
        });
        this.getList();
        loading.close();
      }).catch(err => {
        console.log(err);
        loading.close();
      })
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '操作已取消'
      });
    });
  }
  private async putMakeUpInfoUpdate() {
    // 确定
    let data = {
      amount: this.BuChaForm.amount,
      remark: this.BuChaForm.remark,
    }
    await putMakeUpInfoUpdate(this.bookingOrderId,data).then(res => {
      this.$notify({
        title: "提示",
        message: "提交成功",
        type: "success",
        duration: 2000
      });
      this.showBuCha = false
      this.getList()
    }).catch(err => {
      console.log(err)
    })
  }
  private async putMakeUpInfoReset() {
    // 重置
    this.$confirm("确定重置吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(async () => {
      await putMakeUpInfoReset(this.bookingOrderId).then(res =>{
        this.$notify({
          title: "提示",
          message: "重置成功",
          type: "success",
          duration: 2000
        });
        this.getList()
      }).catch(err => {
        console.log(err)
      })
    })
    .catch((err) => {
      console.error(err);
    });
  }
  private async queryDownload(data) {
    const params = Object.assign({}, this.listParam);
    await downloadAllocationPage(params);
  }
}
